export function get({ params }) {
  return {
    url: `/api/threads/${params.id}`,
    method: 'GET',
    headers: {
      Accept: 'application/ld+json',
      Authorization: null,
    },
  }
}

export function create({ payload }) {
  return {
    url: `/api/threads`,
    method: 'POST',
    headers: {
      Accept: 'application/ld+json',
      'Content-Type': 'application/json',
      Authorization: null,
    },
    body: JSON.stringify(payload),
  }
}

export function postMessage({ payload }) {
  return {
    url: `/api/threads/${payload.thread}/new_message`,
    method: 'POST',
    headers: {
      Accept: 'application/ld+json',
      'Content-Type': 'application/json',
      Authorization: null,
    },
    body: JSON.stringify(payload),
  }
}

export function getUnreads() {
  return {
    url: `/api/unread_messages`,
    method: 'GET',
    headers: {
      Accept: 'application/json',
      Authorization: null,
    },
  }
}
